'use client'

import React from 'react'

interface HeaderLogoProps {
  Link: React.ComponentType<{
    href: string
    className: string
    prefetch: boolean
    children: React.ReactNode
  }>
}

/**
 * Header Logo Component
 * Displays dual logos (white/black) with theme switching
 */
export function HeaderLogo({ Link }: HeaderLogoProps) {
  return (
    <Link href="/" className="logo" prefetch={false}>
      <img
        src="/logo-white.svg"
        alt="APEX Experience"
        className="logo-img logo-white"
        width="120"
        height="40"
      />
      <img
        src="/LOGO-BLACK.svg"
        alt="APEX Experience"
        className="logo-img logo-black"
        width="120"
        height="40"
      />
    </Link>
  )
}
